import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, setGA4UserProperties } from '@/hooks/useFunnelTracking';
import { initAllGA4Advanced, startEngagementTimer, startScrollDepthTracking } from '@/lib/ga4Advanced';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Set GA4 user properties + init advanced tracking once per session
  useEffect(() => {
    setGA4UserProperties();
    initAllGA4Advanced();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    // Track page view for funnel analytics (non-admin pages only)
    if (!pathname.startsWith('/admin')) {
      trackPageView(pathname);
      startEngagementTimer(pathname);
      startScrollDepthTracking(pathname);
    }
  }, [pathname]);

  return null;
};
